
<template>
    <section class="tab__wrapper" v-cloak>
        <header role="tablist" aria-controls="tab-content" aria-label="Tabs">
            <div
                v-for="({ name, isActive, tabIndex, tabReference }) in tabs"
                :key="name"
                role="tab"
                ref="tab"
                :aria-selected="isActive"
                :class="['tab__button', { 'tab__button--active' : isActive }]"
                :tabindex="tabIndex"
                :title="name"
                @click="selectTab(name, tabReference)"
            >
                {{ name }}
            </div>

            <div class="tab__indicator" ref="indicator" />
        </header>

        <section id="tab-content" :class="`tab__container tab__container--${currTab}`" aria-role="region" aria-live="polite">
            <slot></slot>
        </section>
    </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import gsap from 'gsap'

export default {
    props: {
        lockedTabs: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            tabs: [],
            currTab: null,
            selectedTabObj: null
        }
    },

    computed: {
        ...mapState('Resources', ['lockTabs'])
    },

    mounted () {
        this.updateSelectedTabObj()

        this.tabs = this.$children
        this.currTab = this.selectedTabObj.name.split(' ').join('').toLowerCase()

        // we pass the selected tab reference (ie presentation & triage) up to the Area page.
        // This allows us to generate and rebuild the sticky nav based on what tab is selected
        if (this.selectedTabObj && this.selectedTabObj.tabReference) {
            this.$emit('initiatedTabs', this.selectedTabObj.tabReference)
        }

        this.$nextTick(() => {
            this.moveIndicator()

            window.addEventListener('resize', this.moveIndicator)
        })
    },

    methods: {
        ...mapActions('Resources', ['unlockVuexTabs']),

        updateSelectedTabObj () {
            this.selectedTabObj = this.$children.filter(tab => tab.selected)[0]
        },

        selectTab (selectedTab, tabReference) {
            if (tabReference) {
                this.$emit('changedTab', tabReference)
            }

            this.currTab = selectedTab.split(' ').join('').toLowerCase()

            if (this.lockedTabs || this.lockTabs) {
                const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
                if (answer) {
                    this.$emit('unlockTabs', this.tabs)
                    this.unlockVuexTabs()
                }
                else return false
            }

            this.tabs.forEach(tab => {
                const matches = (tab.name == selectedTab)

                tab.isActive = matches
                tab.tabIndex = matches ? 0 : -1 // this is to help with accessible tabbing
            })

            this.$nextTick(() => {
                this.moveIndicator()
            })
        },

        moveIndicator () {
            const { indicator, tab } = this.$refs
            const activeClass = t => t.classList.value.includes('tab__button--active') // TODO: FIX FOR IE11
            const activeTab = tab.filter(activeClass)[0].getBoundingClientRect()
            const newSize = activeTab.width
            const newPosition = activeTab.left

            gsap.to(indicator, {
                width: newSize,
                left: newPosition,
                duration: 0.25,
                ease: 'back.out(1.3)'
            })
        }
    },

    beforeDestroy () {
        window.removeEventListener('resize', this.moveIndicator)
    }
}
</script>

